import { Button, Form, Modal, message } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteBranch } from "../../../../api/branches";

const DeleteBranch = ({ isVisible, setVisible, selected }: any) => {
  const { id } = selected;
  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: deleteBranch,
    onError: (error) => {
      message.error(`${error}`);
    },
    onSuccess: () => {
      message.success("Deleted Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["branches"] });
      setVisible(false);
    },
  });

  const onSubmit = async () => {
    mutate({ id });
  };

  return (
    <>
      <Modal
        title="Delete Branch"
        open={isVisible}
        onCancel={() => setVisible(false)}
        footer={[
          <Button key="back" onClick={() => setVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            form="deleteBranch"
            htmlType="submit"
            onSubmit={onSubmit}
            loading={isLoading}
            className="border-0 bg-blue-600 text-white"
          >
            Delete
          </Button>,
        ]}
      >
        <Form
          id="deleteBranch"
          form={form}
          name="control-ref"
          onFinish={onSubmit}
          layout="vertical"
        >
          <div className="flex flex-col justify-center items-center">
            <div className="">
              Are you sure you want to
              <span className="text-red-600 px-1 font-bold">Delete</span>Branch
            </div>
            <div className="font-bold">{selected?.name} ?</div>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default DeleteBranch;
